// src/components/ProgressBar.js
import React from 'react';
import './MuultiStyle.css';

export default function ProgressBar({ step }) {
    // we have 4 total “screens”: Connect, Choose Name, Choose Template, Editor
    const total = 4;
    // map your internal step values to a 1–4 index
    const index = step === 0 ? 1 : step === 2 ? 2 : step === 3 ? 3 : 4;
    const percent = Math.round((index / total) * 100);

    return (
        <>
            <h3>Setup Progress</h3>
            {step ===  0 &&  <p>Connect your Solana Wallet</p>}
            {step ===  2 &&  <p>Choose a name for your Muulti Space</p>}
            {step ===  3 &&  <p>Select a template</p>}
        <div className="progress-bar">
            <div
                className="progress-bar__fill"
                style={{ width: `${percent}%` }}
            />


        </div>


            </>
    );
}
